<div class="rate-agreement-container body-content-area">
    <div class="breadcrumb-area left-align">
        <p><a routerLink="/home"><u>Home</u> </a><span> > </span><span> Contact</span></p>
    </div>
    <div class="header-area left-align">
        <span class="sub-title">Contact</span>
    </div>
    <div class="table-area content-area">
        <app-contact-table></app-contact-table>
    </div>
    
</div>

